export default {
    SET_PAYOUT_LOGS: (state, payoutLogs) => {
        state.payoutLogs = payoutLogs
    },

    SET_PAGINATION: (state, pagination) => {
        state.pagination = pagination
    },

    SET_LOAD: (state, isLoaded) => {
        state.isLoaded = isLoaded
    }
}
